// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__1BHfS","footer_mobileMenu":"footer_mobileMenu__3GZKg","transitionMenuOut":"transitionMenuOut__2i5pM","footer_menu":"footer_menu__3e-67","footer_menu_item":"footer_menu_item__ZOvki","footer_menu_item__selected":"footer_menu_item__selected__4YgrZ"};


//////////////////
// WEBPACK FOOTER
// ./components/Footer/Footer.scss
// module id = V81E
// module chunks = 0